/**
 * Pure derivations for the live overview screen.
 *
 * Deterministic, no clock, no DOM.
 */

import type { LiveOverviewResponse } from "@/api/generated/model";

/**
 * The overview's honest freshness instant: the latest feed `measuredAt` across
 * hospitals that have a reading, or `null` when none do.
 *
 * NOT `generatedAt` — that is stamped fresh on every response, so feeding it to
 * the freshness badge made the badge read "adesso" even over a frozen feed. The
 * feed's own `measuredAt` (ISO-8601 UTC, so lexicographic max = latest) is the
 * real reading time. Fixes #89 §C.
 */
export function overviewMeasuredAt(data: LiveOverviewResponse | undefined): string | null {
  if (!data) return null;
  let latest: string | null = null;
  for (const h of data.hospitals) {
    if (h.hasData && h.measuredAt !== null && (latest === null || h.measuredAt > latest)) {
      latest = h.measuredAt;
    }
  }
  return latest;
}
